import React, { useEffect, useState, useContext } from 'react'
import { apiGet, apiPost } from '../../utils/apiFetch'
import apiPath from '../../utils/pathObj'
import { useForm } from 'react-hook-form'
import useToastContext from 'hooks/useToastContext'
import ErrorMessage from 'components/ErrorMessage'
import { useTranslation } from 'react-i18next'
import OInputField from 'components/reusable/OInputField'
import { preventMaxInput } from 'utils/validations'
import formValidation from '../../utils/formValidation'
import AuthContext from 'context/AuthContext'

const SkillAdd = ({ allSkill, handleCategory }) => {
  const { t } = useTranslation()
  const notification = useToastContext()
  const [recordsTemp, setRecordTemp] = useState([])
  const [cat, setCat] = useState('')
  const {
    register,
    handleSubmit,
    clearErrors,
    setError,
    formState: { errors }
  } = useForm({
    mode: 'onChange',
    shouldFocusError: true,
    defaultValues: {}
  })
  const { user } = useContext(AuthContext)
  const [companyData] = useState(user?._id)

  const onSubmit = async data => {
    try {
      const payload = {
        departmentID: cat,
        name: data?.name,
        companyID: companyData
      }
      const res = await apiPost(apiPath.skillAdd, payload)
      if (res?.data?.success === true) {
        allSkill()
        handleCategory(false)
        notification.success(res?.data?.message)
      } else {
        notification.error(res?.data?.message)
      }
    } catch (err) {
      console.log('err:', err)
    }
  }

  const getDepartmentList = async () => {
    try {
      const res = await apiGet(apiPath.getDepartmentList, {})
      setRecordTemp(res?.data?.results)
    } catch (error) {
      console.log('error:', error)
    }
  }

  useEffect(() => {
    getDepartmentList()
  }, [])

  const selectCategory = e => {
    if (e.target.value) {
      setCat(e.target.value)
      clearErrors('departmentID')
    } else {
      setCat('')
      setError('departmentID', {
        type: 'validation',
        message: 'Please select department.'
      })
    }
  }

  return (
    <>
      <div className='justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none'>
        <div className='relative w-auto my-6 mx-auto max-w-3xl'>
          <div className='md:py-4 sm:px-2 sm:py-8 px-7'>
            <div className='border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none min-w-[762px]'>
              {/*header*/}
              <div className='flex items-center justify-between p-5 border-b border-solid border-slate-200 rounded-t'>
                <h3 className='text-xl font-semibold'>{t('ADD_SKILL')}</h3>
                <button
                  className=' ml-auto flex items-center justify-center  text-black border-2 rounded-full  h-8 w-8 float-right text-3xl leading-none font-extralight outline-none focus:outline-none'
                  onClick={() => handleCategory(false)}
                  title='Close'
                >
                  <span className=' text-[#B8BBBF]  text-4xl ' title='Close'>
                    ×
                  </span>
                </button>
              </div>
              {/*body*/}
              <div className='flex-auto relative p-6 '>
                <div className='sm:grid-cols-2 grid'>
                  <div className='px-7 md:py-4 sm:px-2 sm:py-8 '>
                    <div className='z-0 relative w-full group'>
                      <select
                        placeholder=' '
                        value={cat}
                        type='select'
                        id='departmentID'
                        className='dark:text-white block py-4 px-3 w-full text-sm text-gray-900 bg-transparent border-2 rounded-lg border-[#DFDFDF] appearance-none dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0  peer'
                        {...register('departmentID', {
                          required: 'Please select department.'
                        })}
                        onChange={selectCategory}
                      >
                        <option value=''>{t('SELECT_DEPARTMENT')}</option>
                        {recordsTemp &&
                          recordsTemp.map(item => {
                            return (
                              <option value={item?._id}>{item?.name}</option>
                            )
                          })}
                      </select>
                      <label
                        className='dark:text-gray-400 duration-300 peer-focus:font-normal absolute text-sm text-[#A5A5A5] transform -translate-y-6 scale-75 top-3 left-3 bg-white p-2 z-10 origin-[2] peer-focus:left-0 peer-focus:text-[#A5A5A5] peer-focus:text-lg peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-8'
                        htmlFor='departmentID'
                      >
                        {' '}
                        {t('SELECT_DEPARTMENT')}
                        <span className='text-red-500'>*</span>
                      </label>
                      <ErrorMessage message={errors?.departmentID?.message} />
                    </div>
                  </div>
                  <div className='sm:px-2 md:py-4 sm:py-8 px-7'>
                    <OInputField
                      wrapperClassName='relative w-full z-0 group'
                      autoFocus={true}
                      type='text'
                      name='name'
                      id='name'
                      inputLabel={
                        <>
                          {t('SKILL_NAME')}
                          <span className='text-red-500'>*</span>
                        </>
                      }
                      placeholder=''
                      onInput={e => preventMaxInput(e, 100)}
                      maxLength={100}
                      register={register('name', formValidation['skillName'])}
                      errors={errors}
                    />
                  </div>
                </div>
              </div>
              <div className='border-t flex items-center justify-center p-6 border-solid border-slate-200 rounded-b'>
                <button
                  onClick={() => handleCategory(false)}
                  className='rounded mr-6  ease-linear text-black bg-[#E1E1E1] font-normal px-12 py-2.5 text-sm outline-none focus:outline-none transition-all duration-150'
                  type='button'
                >
                  {t('O_BACK')}
                </button>
                <button
                  type='submit'
                  className='px-8 py-2.5 bg-LightBlue text-white active:bg-emerald-600 font-normal text-sm rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1  ease-linear transition-all duration-150'
                  onClick={handleSubmit(onSubmit)}
                >
                  {t('O_ADD')}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className='fixed opacity-25 inset-0 z-40 bg-black' />
    </>
  )
}

export default SkillAdd
